import { createFileRoute } from '@tanstack/react-router'
import { CompanyContractPage } from '@/features/companies/contract'

export const Route = createFileRoute('/companies_/$companyId/contract')({
  component: RouteComponent,
})

function RouteComponent() {
  const { companyId } = Route.useParams()
  return <CompanyContractPage companyId={companyId} />
}
